import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trip-contributors',
  templateUrl: './trip-contributors.component.html',
  styleUrls: ['./trip-contributors.component.css']
})
export class TripContributorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
